"use strict";

module.exports = {
  percent: '%',
  px: 'px',
  angle: '\xB0',
  seconds: 's'
};